import {
  Compiler,
  Component,
  ContentChild,
  Injectable,
  Injector,
  NgModule,
  TemplateRef,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import * as ts from "typescript";
import {CommonModule} from "@angular/common";
import {BrowserModule} from "@angular/platform-browser";
import {TemplateCompilerOptions} from "./template-compiler-options";
import {SharedModule} from "../../../shared/shared.module";
import {CoreModule} from "../../core.module";
import {ChipListAllModule} from "@syncfusion/ej2-angular-buttons";

@Injectable({
  providedIn: 'root'
})
export class TemplateCompilerService {

  constructor(private compiler: Compiler) { }

  async compileTemplate(template: string, templateName: string, vcRef: ViewContainerRef, compRef: any, options: TemplateCompilerOptions = {}) {
    const start = new Date().getTime();
    try {

      const namedTemplate = template.replace("<ng-template", `<ng-template #${templateName}`);

      const contentStart = namedTemplate.indexOf('>') + 1;
      const contentEnd = namedTemplate.indexOf('</ng-template>');

      const intro = namedTemplate.substring(0, contentStart);
      const content = namedTemplate.substring(contentStart, contentEnd);
      const outro = namedTemplate.substring(contentEnd);

      // TODO: At this point we can insert code around content by setting prefix and suffix
      let prefix = "";
      let suffix = "";

      if (options.debugStyle) {
        prefix = `<div style="${options.debugStyle}">`;
        suffix = '</div>';
      }

      const wrappedTemplate = intro + prefix + content + suffix + outro;

      // Can add more Component decorator options here
      const metadata = new Component({
        selector: "compiled-at-runtime",
        template: wrappedTemplate
      });

      const implementation = `class DynamicComponent {
      public comp;
      public @ViewChild("${templateName}", {static: true, read: TemplateRef) templateRef: TemplateRef<any>;
    }`;

      const transpiledImplementation = ts.transpile(implementation, {
        target: ts.ScriptTarget.ES2015,
        emitDecoratorMetadata: true
      });

      (window as any).ViewChild = ViewChild;
      (window as any).ContentChild = ContentChild;
      (window as any).TemplateRef = TemplateRef;

      const componentImpl = eval(`${transpiledImplementation};
      DynamicComponent;`);

      const decoratedCmp = Component(metadata)(componentImpl);

      // Can add modules here so we can include them in templates, we could be adding a lot more Syncfusion ones
      const moduleDef = NgModule({
        imports: [
          CommonModule,
          BrowserModule,
          SharedModule,
          CoreModule,
          ChipListAllModule
        ],
        declarations: [decoratedCmp],
        entryComponents: [decoratedCmp]
      })(class DynamicHtmlModule {
      });

      const moduleWithComponentFactory = await this.compiler.compileModuleAndAllComponentsAsync(moduleDef);

      const factory = moduleWithComponentFactory.componentFactories.find(x => x.componentType === componentImpl);

      // Can add providers here
      const injector = Injector.create({
        providers: [],
        parent: vcRef.injector
      });

      const newComponentRef = vcRef.createComponent(factory, 0, injector, []);
      const newInstance = (newComponentRef as any).instance;

      newInstance.comp = compRef;

      return newInstance.templateRef;
    } finally {
      const end = new Date().getTime();
      console.debug(`TemplateCompilerService.compileTemplate ${templateName} took ${end - start}ms`);
    }
  }
}
